import { render, staticRenderFns } from "./PurchaseFormModal.vue?vue&type=template&id=bec1b584&"
import script from "./PurchaseFormModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseFormModal.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseFormModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports